import React from "react";
import { Link } from "react-router-dom";

interface Props {
  to: string;
  inSideDrawer?: boolean;
}

const Anchor: React.FC<Props> = (props) => {
  return (
    <Link to={props.to} className={`${props.inSideDrawer ? "defaultText" : "text-white"} link`}>
      {props.children}
    </Link>
  );
};

export default Anchor;
